const RESOURCE_NAME = '/drivers';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),

    getPhoto(id, params) {
        return axios.get(`${RESOURCE_NAME}/${id}/photo`, {params});
    }
});